// GET product name from product code
export const getProductNameFromCode = (products, productCode) => {
    let productName = ""
    for (let i = 0; i < products.length; i++){
        if (products[i].product_code === productCode) {
            productName = products[i].product_name;
            break;
        }
    }
    if (productName === "") return productCode
    return productName
}